import React from "react"
import ReactDOM from "react-dom/client"
import "./dagger.css"
import Dagger from "./dagger"

const root = ReactDOM.createRoot(document.getElementById("dagger-root"))
root.render(<Dagger />)
